import _ from 'lodash';
import * as ActionType from '../actions/actionType';

const innitialState = {
};

const receivedContent = (state, action) => {
  const content = _.get(action, 'content.data');
  return [...content];
};

export default (state = innitialState, action) => {
  switch (action.type) {
    case ActionType.GET_INSTAGRAM:
      return receivedContent(state, action);
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/instagram.js